import { ChatCustomBlockTypes, type ChatOpenCustomBlock } from "@do/shared-types";

export const isEmptyTextBlock = (block: ChatOpenCustomBlock) =>
  block.type === ChatCustomBlockTypes.text && block?.text === "";
